module.exports = __webpack_public_path__ + "img/authorityLogo11.ee9d00cc.png";